import { Location } from '@era/inroom-sdk';

import { Action } from '@ngrx/store';

export enum LocationActionTypes {
  LOCATION_API_LOCATIONS_LOADED = '[Location API] Locations Loaded',
  LOCATION_API_LOCATION_ADDED = '[Location API] Location Added',
  LOCATION_API_LOCATION_DELETED = '[Location API] Location Deleted',

  LOCATION_HEADER_LOCATION_DELETED = '[Location Header] Location Deleted',
  LOCATION_RESOLVER_LOCATION_SELECTED = '[Location Resolver] Location Selected',

  LOCATION_EFFECT_NAVIGATED_BACK = '[Location Effect] Navigated Back',
  LOCATION_ADD_MODAL_CONFIRMED = '[Location Add Modal] Add Confirmed',
}

export class LocationApiLocationsLoaded implements Action {
  readonly type = LocationActionTypes.LOCATION_API_LOCATIONS_LOADED;

  constructor(public payload: Location[]) {}
}

export class LocationApiLocationAdded implements Action {
  readonly type = LocationActionTypes.LOCATION_API_LOCATION_ADDED;

  constructor(public payload: Location) {}
}

export class LocationApiLocationDeleted implements Action {
  readonly type = LocationActionTypes.LOCATION_API_LOCATION_DELETED;

  constructor(public payload: Location) {}
}

export class LocationResolverLocationSelected implements Action {
  readonly type = LocationActionTypes.LOCATION_RESOLVER_LOCATION_SELECTED;

  constructor(public payload: Location) {}
}

export class LocationAddModalConfirmed implements Action {
  readonly type = LocationActionTypes.LOCATION_ADD_MODAL_CONFIRMED;

  constructor(public payload: Location) {}
}

export class LocationHeaderLocationDeleted implements Action {
  readonly type = LocationActionTypes.LOCATION_HEADER_LOCATION_DELETED;

  constructor(public payload: Location) {}
}

export class LocationEffectNavigatedBack implements Action {
  readonly type = LocationActionTypes.LOCATION_EFFECT_NAVIGATED_BACK;
}

export type LocationActionsUnion =
  | LocationApiLocationsLoaded
  | LocationApiLocationAdded
  | LocationApiLocationDeleted
  | LocationResolverLocationSelected
  | LocationHeaderLocationDeleted
  | LocationEffectNavigatedBack
  | LocationAddModalConfirmed;
